import {findID, onReady} from "../../../../modules/vegas/js/util";
import Masonry from 'masonry-layout';

function initMasonry() {
	let gridAbout = findID('row-grid-about');
	if(gridAbout) {
		new Masonry( gridAbout, {
			itemSelector: '.col-xl-6',
		});
	}
}
onReady(initMasonry);
typeof onTurboRender !== 'undefined' && onTurboRender(initMasonry);
